import { render, staticRenderFns } from "./BDataTable.vue?vue&type=template&id=dc2a3338"
import script from "./BDataTable.vue?vue&type=script&lang=js"
export * from "./BDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports